<template>
  <div class="form-inline">
    <select v-if="showOperator" v-model="filter.operator" class="form-control form-control-sm">
      <option v-for="operator in operators" :value="operator.value">
        {{ operator.label }}
      </option>
    </select>
    <input
      v-if="filter.operator !== 'isNull'"
      v-model="filter.value"
      class="form-control form-control-sm"
      @keyup.enter="$emit('submit')"
    >
  </div>
</template>

<script>
  import { operators } from './numeric';

  export default {
    props: {
      filter: {
        type: Object,
        required: true,
      },
      showOperator: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        operators
      };
    },
    beforeMount() {
      if (!this.filter.value) {
        this.filter.value = '';
      }
      if (!this.filter.operator) {
        this.filter.operator = operators[0].value;
      }
    },
  };
</script>
<style scoped>
  select {
    width: 80px;
  }
</style>